import React, { Component } from "react";
import FailMessageModal from "./FailMessageModal";

class BindingFailBox extends Component {
  render() {
    const { binding, selRoleId, showModalFailMessage, handleShowModalFailMessage, handleCloseModalFailMessage } = this.props;
    const fontSize = window.innerWidth > 480?"1.5rem":"12px";
    return (
        <div className="col-lg-6">
          <div className="number">
            <div className="col-xs-2"> <img src={binding.logo_path} /></div>
            <div className="col-xs-6 box1">
            <p>{binding.game_name}</p>
              <span style={{color: "#747474", lineHeight: "1.5", fontSize: fontSize}}>伺服器：{binding.server_name}</span><br />
              <span style={{color: "#747474", lineHeight: "1.5", fontSize: fontSize}}>角色ID：{binding.role_id}</span> </div>
            <div className="col-xs-4 fail"> <span>{binding.review_result === 2 ? "綁定失敗" : "取消申請"}</span>
              { binding.review_result === 2 && (
                <button type="button" onClick={(e) => handleShowModalFailMessage(binding.role_id)}>詳情</button>
              )}
            </div>
          </div>
          <FailMessageModal binding={binding} selRoleId={selRoleId} showModalFailMessage={showModalFailMessage} handleCloseModalFailMessage={handleCloseModalFailMessage}></FailMessageModal>
        </div>
    );
  }
}

export default BindingFailBox;
